

import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Modal from '@mui/material/Modal';

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React examples
import DataTable from "examples/Tables/DataTable";
import { Tooltip, IconButton, Badge } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EntityAddressItemSelectDataTable from "./datatable";
import CrudService from 'services/cruds-service';

const ModalEntitySelect = ({ entityList, entityItem, setEntityItem }) => {
    const [open, setOpen] = useState(false);
    const [selectedRows, setSelectedRows] = useState([entityItem.length ? entityItem[0]?.id : null]);
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        if (entityList.length > 0) {
            setTableData(getRows(entityList))
        }
    }, [entityList])

    const removeAddress = (index) => {
        setEntityItem([]);
    };

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const addressHandler = () => {
        // setAddresses([...addresses, newAddress]);
        const filteredAddresses = entityList.filter(address => selectedRows.includes(address.id));
        setEntityItem(filteredAddresses);
        setOpen(false);
    };

    const getRows = (info) => {
        let updatedInfo = info.map((row, index) => {
            let entityName = row.attributes.name
            if (
                !entityName &&
                row.attributes.first_name &&
                row.attributes.last_name
            ) {
                entityName = `${row.attributes.first_name} ${row.attributes.last_name}`
            }
            const defaultIndex = row.moduleLocations.findIndex(
                (location) => location.is_default === true,
            )

            return {
                type: 'entities',
                id: row.attributes.entity_id,
                name: entityName,
                company: row.attributes.Company?.name,
                type: row.attributes.EntityType?.type_name,
                // status: (
                //     <Badge
                //         color={
                //             row.attributes?.StatusOption?.BadgeDetail?.color || 'primary'
                //         }
                //         variant={row.attributes?.StatusOption?.BadgeDetail?.variant}
                //         badgeContent={row.attributes?.StatusOption?.StatusType?.status_name}
                //         style={{ marginLeft: '30px' }}
                //     ></Badge>
                // ),
                status: {
                    color: row.attributes?.StatusOption?.BadgeDetail?.color || 'primary',
                    variant: row.attributes?.StatusOption?.BadgeDetail?.variant,
                    status_name: row.attributes?.StatusOption?.StatusType?.status_name
                },
                address: row.moduleLocations[defaultIndex]?.Address?.street_address1,
                city: row.moduleLocations[defaultIndex]?.Address?.city,
                state: row.moduleLocations[defaultIndex]?.Address?.state,
                country: row.moduleLocations[defaultIndex]?.Address?.country,
                postal_code: row.moduleLocations[defaultIndex]?.Address?.postal_code,
                latitude: row.moduleLocations[defaultIndex]?.Address?.latitude,
                longitude: row.moduleLocations[defaultIndex]?.Address?.longitude,
                created_by_user_id: row.attributes.created_by_user_id
            };
        });
        return updatedInfo;
    };

    const dataTableData = {
        columns: [
            { Header: 'ID', accessor: 'id', width: '5%' },
            {
                Header: 'Status', accessor: 'status', width: '15%', Cell: (info) => {
                    return (
                        <Badge
                            color={info.value?.color}
                            variant={info.value?.variant}
                            badgeContent={info.value?.status_name}
                            style={{ marginLeft: '30px' }}
                        ></Badge>
                    )
                }
            },
            { Header: 'Entity Name', accessor: 'name', width: '20%' },
            { Header: 'Company', accessor: 'company', width: '20%' },
            { Header: 'Type', accessor: 'type', width: '20%' },
            { Header: 'Address 1', accessor: 'address', width: '10%' },
            { Header: 'City', accessor: 'city', width: '20%' },
            { Header: 'State', accessor: 'state', width: '10%' },
            { Header: 'Country', accessor: 'country', width: '10%' },
            { Header: 'Postal Code', accessor: 'postal_code', width: '10%' },
            { Header: 'Latitude', accessor: 'latitude', width: '10%' },
            { Header: 'Longitude', accessor: 'longitude', width: '10%' },
            {
                Header: "actions",
                disableSortBy: true,
                accessor: "",
                Cell: (info) => {
                    return (
                        <MDBox display="flex" alignItems="center">
                            {(
                                <Tooltip title="Delete Company">
                                    <IconButton onClick={() => removeAddress(info.cell.row.original.id)}>
                                        <MDTypography><DeleteIcon /></MDTypography>
                                    </IconButton>
                                </Tooltip>
                            )}
                        </MDBox>
                    );
                },
            }
        ],

        rows: getRows(entityItem),
    };

    return (
        <Card sx={{ marginBottom: 1 }}>
            <MDBox display="flex" flexDirection="column" px={3} my={2}>
                <MDBox display="flex" flexDirection="column" style={{ marginTop: "1rem" }}>
                    <MDBox
                        display="flex"
                    >
                        <MDTypography fontWeight="bold">
                            Entity
                        </MDTypography>
                        <MDButton variant="gradient" color="dark" size="small" style={{ marginLeft: "1rem" }} onClick={handleOpen}>Assign Device</MDButton>
                    </MDBox>

                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <Card
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '80%', // Set the desired width here
                                backgroundColor: 'white',
                                border: '2px solid #000',
                                boxShadow: 24,
                                p: 4,
                            }}
                        >
                            {/* <CardContent> */}
                            {/* <MDTypography>Select Entity Address Item</MDTypography> */}
                            <EntityAddressItemSelectDataTable rowData={tableData} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
                            <MDBox ml="auto" mt={3} display="flex" justifyContent="flex-end">
                                <MDButton variant="contained" color="secondary" onClick={handleClose}>
                                    Cancel
                                </MDButton>
                                <MDButton variant="contained" color="info" onClick={addressHandler} style={{ marginLeft: '10px' }}>
                                    Save
                                </MDButton>
                            </MDBox>
                            {/* </CardContent> */}
                        </Card>
                    </Modal>

                </MDBox>
                <MDBox>
                    {entityItem.length > 0 && (
                        <DataTable
                            table={dataTableData}
                            canSearch={true}
                            tableHeight="calc(100vh - 410px)"
                        />
                    )}
                </MDBox>
            </MDBox>
        </Card>
    );
};

export default ModalEntitySelect;
